import React from 'react'

const WifiIcon = ({ height, width, color }: { height: string; width: string; color: string }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path
        d='M1.3164 4.54974C5.55975 0.316752 12.4402 0.316752 16.6836 4.54974L17.5664 3.66478C12.8351 -1.05493 5.16486 -1.05493 0.433594 3.66478L1.3164 4.54974Z'
        fill={color}
      />
      <path
        d='M3.70609 6.93362C6.62966 4.0172 11.3703 4.0172 14.2939 6.93362L15.1767 6.04866C11.7652 2.64553 6.23476 2.64553 2.82329 6.04866L3.70609 6.93362Z'
        fill={color}
      />
      <path
        d='M6.09579 9.31748C7.69956 7.71764 10.3004 7.71764 11.9042 9.31748L12.787 8.43252C10.6953 6.34596 7.30466 6.34596 5.21299 8.43252L6.09579 9.31748Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.99999 10.125C7.96446 10.125 7.12499 10.9645 7.12499 12C7.12499 13.0355 7.96446 13.875 8.99999 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 8.99999 10.125ZM8.37499 12C8.37499 11.6548 8.65481 11.375 8.99999 11.375C9.34517 11.375 9.62499 11.6548 9.62499 12C9.62499 12.3452 9.34517 12.625 8.99999 12.625C8.65481 12.625 8.37499 12.3452 8.37499 12Z'
        fill={color}
      />
    </svg>
  )
}

export default WifiIcon
